import { ref } from 'vue';
import dayjs from 'dayjs';
import $url from '@/sheep/url';
import { formatDate } from '@/sheep/util';

/**
 * 格式化销量
 * @param {'exact' | string} type 格式类型：exact=精确值，其它=大致数量
 * @param {number} num 销量
 * @return {string} 格式化后的销量字符串
 */
export function formatSales(type, num) {
  let prefix = type !== 'exact' && num < 10 ? '销量' : '已售';
  return formatNum(prefix, type, num)
}

/**
 * 格式化兑换量
 * @param {'exact' | string} type 格式类型：exact=精确值，其它=大致数量
 * @param {number} num 销量
 * @return {string} 格式化后的销量字符串
 */
export function formatExchange(type, num) {
  return formatNum('已兑换', type, num)
}


/**
 * 格式化库存
 * @param {'exact' | any} type 格式类型：exact=精确值，其它=大致数量
 * @param {number} num 销量
 * @return {string} 格式化后的销量字符串
 */
export function formatStock(type, num) {
  return formatNum('库存', type, num)
}

/**
 * 格式化数字
 * @param {string} prefix 前缀
 * @param {'exact' | string} type 格式类型：exact=精确值，其它=大致数量
 * @param {number} num 销量
 * @return {string} 格式化后的销量字符串
 */
export function formatNum(prefix, type, num) {
  num = (num || 0);
  // 情况一：精确数值
  if (type === 'exact') {
    return prefix + num;
  }
  // 情况二：小于等于 10
  if (num < 10) {
    return `${prefix}≤10`;
  }
  // 情况三：大于 10，除第一位外，其它位都显示为0
  // 例如：100  - 199  显示为 100+
  //      9000 - 9999 显示为 9000+
  const numStr = num.toString();
  const first = numStr[0];
  const other = '0'.repeat(numStr.length - 1);
  return `${prefix}${first}${other}+`;
}

// 格式化价格
export function formatPrice(e) {
  return e.length === 1 ? e[0] : e.join('~');
}

// 视频格式后缀列表
const VIDEO_SUFFIX_LIST = ['.avi', '.mp4']

/**
 * 转换商品轮播的链接列表：根据链接的后缀，判断是视频链接还是图片链接
 *
 * @param {string[]} urlList 链接列表
 * @return {{src: string, type: 'video' | 'image' }[]}  转换后的链接列表
 */
export function formatGoodsSwiper(urlList) {
  return urlList?.filter(url => url).map((url, key) => {
    const isVideo = VIDEO_SUFFIX_LIST.some(suffix => url.includes(suffix));
    const type = isVideo ? 'video' : 'image'
    const src = $url.cdn(url);
    return { type, src }
  }) || [];
}

/**
 * 格式化订单状态的颜色
 *
 * @param order 订单
 * @return {string} 颜色的 class 名称
 */
export function formatOrderColor(order) {
  if (order.status === 0) {
    return 'info-color';
  }
  if (order.status === 10
    || order.status === 20
    || order.status === 50
    || (order.status === 30 && !order.commentStatus)) {
    return 'warning-color';
  }
  if ((order.status === 30 && order.commentStatus) || order.status === 2) {
    return 'success-color';
  }
  return 'danger-color';
}

export function formatOrderColor1(order) {
  if (order.orderState == 6
    || order.orderState == 8
    || order.orderState == 0
    || order.orderState == 10) {
    return 'danger-color';
  }
  if (order.orderState == 3
    || order.orderState == 4
    || order.orderState == 5
    || order.orderState == 7) {
    return 'warning-color';
  }
  if (order.orderState == 1
    || order.orderState == 2
    || order.orderState == 11
    || order.orderState == 12
    || order.orderState == 9
    || order.orderState == 13) {
    return 'success-color';
  }
  return 'info-color';

}
/**
 * 格式化订单状态
 *
 * @param order 订单
 */
export function formatOrderStatus(order) {
  // order.deliveryType
  // 快递发货 1  用户自提 2 同城配送 3
  if (order.status === 0) {
    return '待付款';
  }
  if ((order.deliveryType === 4 || order.deliveryType === 5) && order.items[0].chargeStatus === 10) {
    return '充值中';
  }
  if ((order.deliveryType === 4 || order.deliveryType === 5) && order.items[0].chargeStatus === 20) {
    return '充值成功';
  }
  if ((order.deliveryType === 4 || order.deliveryType === 5) && order.items[0].chargeStatus === 30) {
    return '充值失败';
  }
  if (order.status === 10) {
    return '待发货';
  }
  if (order.status === 20 && order.deliveryType === 2) {
    return '待取货';
  }
  if (order.status === 20 && order.deliveryType != 2) {
    return '待收货';
  }

  // if (order.status === 30 && !order.commentStatus) {
  //   return '待评价';
  // }
  if (order.status === 30) {
    return '已完成';
  }
  if (order.status === 40) {
    return '已取消';
  }
  if (order.status === 50) {
    return '部分发货';
  }
  // return '已关闭';
}

/**
 * 格式化订单状态的描述
 *
 * @param order 订单
 */
export function formatOrderStatusDescription(order) {
  if (order.status === 0) {
    return `请在 ${formatDate(order.payExpireTime)} 前完成支付`;
  }
  if (order.deliveryType === 4 && order.items[0].chargeStatus === 10) {
    return '充值中，请耐心等待，24小时内到账';
  }
  if (order.deliveryType === 4 && order.items[0].chargeStatus === 20) {
    return '订单已完成';
  }
  if (order.deliveryType === 4 && order.items[0].chargeStatus === 30) {
    return '请重新下单';
  }
  if (order.status === 10) {
    return '商家未发货，请耐心等待';
  }

  if (order.status === 20 && order.deliveryType === 2) {
    return '商家已发货，请记得取货';
  }
  if (order.status === 20 && order.deliveryType != 2) {
    return '商家已发货，请耐心等待';
  }
  // && !order.commentStatus
  // if (order.status === 30) {
  //   return '已收货，快去评价一下吧';
  // }
  if (order.status === 30) {
    return '交易完成，感谢您的支持';
  }
  if (order.status === 50) {
    return '商品已部分发货，请耐心等待';
  }
  return '交易关闭';
}
/**
 * 格式化订单状态的描述
 *
 * @param movieorder 订单
 */
export function formatOrderStatusDescriptionMovie(order) {
  if (order.status === 0) {//待付款
    return `请在 ${formatDate(order.timeoutTime)} 前完成支付`;
  }
  if (order.status === 1) {
    return '订单已取消';
  }
  if (order.status === 2) {
    return '正在出票请留意手机短信';
  }
  if (order.status === 3) {
    return '已出票成功，感谢您的使用';
  }
  if (order.status === 4) {
    return '出票失败，钱款已原路退回';
  }
  if (order.status === 5) {
    return '退票中，请稍后';
  }
  if (order.status === 6) {
    return '已退票，钱款已原路退回';
  }
  return '交易关闭';
}

/**
 * 处理订单的 button 操作按钮数组
 *
 * @param order 订单
 */
export function handleOrderButtons(order) {
  order.buttons = []
  if (order.type === 3) { // 查看拼团
    order.buttons.push('combination');
  }
  if (order.status === 20) { // 确认收货
    order.buttons.push('confirm');
  }
  if (order.logisticsId > 0) { // 查看物流
    order.buttons.push('express');
  }
  if (order.status === 0) { // 取消订单 / 发起支付
    order.buttons.push('cancel');
    order.buttons.push('pay');
  }
  if (order.status === 30 && !order.commentStatus) { // 发起评价
    order.buttons.push('comment');
  }
  if (order.status === 40) { // 删除订单
    order.buttons.push('delete');
  }
}

/**
 * 格式化售后状态
 *
 * @param afterSale 售后
 */
export function formatAfterSaleStatus(afterSale) {
  if (afterSale.status === 10) {
    return '申请售后';
  }
  if (afterSale.status === 20) {
    return '商品待退货';
  }
  if (afterSale.status === 30) {
    return '商家待收货';
  }
  if (afterSale.status === 40) {
    return '等待退款';
  }
  if (afterSale.status === 50) {
    return '退款成功';
  }
  if (afterSale.status === 61) {
    return '买家取消';
  }
  if (afterSale.status === 62) {
    return '商家拒绝';
  }
  if (afterSale.status === 63) {
    return '商家拒收货';
  }
  return '未知状态';
}

/**
 * 格式化售后状态的描述
 *
 * @param afterSale 售后
 */
export function formatAfterSaleStatusDescription(afterSale) {
  if (afterSale.status === 10) {
    return '退款申请待商家处理';
  }
  if (afterSale.status === 20) {
    return '请退货并填写物流信息';
  }
  if (afterSale.status === 30) {
    return '退货退款申请待商家处理';
  }
  if (afterSale.status === 40) {
    return '等待退款';
  }
  if (afterSale.status === 50) {
    return '退款成功';
  }
  if (afterSale.status === 61) {
    return '退款关闭';
  }
  if (afterSale.status === 62) {
    return `商家不同意退款申请，拒绝原因：${afterSale.auditReason}`;
  }
  if (afterSale.status === 63) {
    return `商家拒绝收货，不同意退款，拒绝原因：${afterSale.auditReason}`;
  }
  return '未知状态';
}

/**
 * 处理售后的 button 操作按钮数组
 *
 * @param afterSale 售后
 */
export function handleAfterSaleButtons(afterSale) {
  afterSale.buttons = [];
  if ([10, 20, 30].includes(afterSale.status)) { // 取消订单
    afterSale.buttons.push('cancel');
  }
  if (afterSale.status === 20) { // 退货信息
    afterSale.buttons.push('delivery');
  }
}

/**
 * 倒计时
 * @param toTime   截止时间
 * @param fromTime 起始时间，默认当前时间
 * @return {{s: string, ms: number, h: string, m: string}} 持续时间
 */
export function useDurationTime(toTime, fromTime = '') {
  toTime = getDayjsTime(toTime);
  if (fromTime === '') {
    fromTime = dayjs();
  }
  let duration = ref(toTime - fromTime);
  if (duration.value > 0) {
    setTimeout(() => {
      if (duration.value > 0) {
        duration.value -= 1000;
      }
    }, 1000);
  }

  let durationTime = dayjs.duration(duration.value);
  return {
    h: (durationTime.months() * 30 * 24 + durationTime.days() * 24 + durationTime.hours())
      .toString()
      .padStart(2, '0'),
    m: durationTime.minutes().toString().padStart(2, '0'),
    s: durationTime.seconds().toString().padStart(2, '0'),
    ms: durationTime.$ms,
  };
}
/**
 * 倒计时天
 */
export function lastDay(time) {
  // 设置未来事件的日期
  // const futureDate = new Date('2024-12-31T23:59:59'); // 你可以根据需要更改这个日期

  // 获取当前日期
  const now = new Date();

  // 计算两个日期之间的毫秒差
  const timeDifference = time - now;

  // 将毫秒转换为天数
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  // 显示倒计时（这里只是简单地输出到控制台，你可以将其显示在网页上）
  console.log(`距离事件还有 ${daysDifference} 天`);

  return daysDifference

}
/**
 * 转换为 Dayjs
 * @param {any} time 时间
 * @return {dayjs.Dayjs}
 */
function getDayjsTime(time) {
  time = time.toString();
  if (time.indexOf('-') > 0) {
    // 'date'
    return dayjs(time);
  }
  if (time.length > 10) {
    // 'timestamp'
    return dayjs(parseInt(time));
  }
  if (time.length === 10) {
    // 'unixTime'
    return dayjs.unix(parseInt(time));
  }
}

/**
 * 将分转成元
 *
 * @param price 分，例如说 100 分
 * @returns {string} 元，例如说 1.00 元
 */
export function fen2yuan(price) {
  if (!price || price === undefined) return 0
  return (price / 100.0).toFixed(2)
}

export function fen1yuan(price) {
  if (!price || price === undefined) return 0
  return (price / 100.0).toFixed(1)
}
export function yuan2fen(price) {
  if (typeof price === 'undefined') return 0
  const parsedNumber = typeof price === 'string' ? parseFloat(price) : price
  return Math.round(parsedNumber * 100)
}

/**
 * 从商品 SKU 数组中，转换出商品属性的数组
 *
 * 类似结构：[{
 *    id: // 属性的编号
 *    name: // 属性的名字
 *    values: [{
 *      id: // 属性值的编号
 *      name: // 属性值的名字
 *    }]
 * }]
 *
 * @param skus 商品 SKU 数组
 */
export function convertProductPropertyList(skus) {
  let result = [];
  for (const sku of skus) {
    if (!sku.properties) {
      continue
    }
    for (const property of sku.properties) {
      // ① 先处理属性
      let resultProperty = result.find(item => item.id === property.propertyId)
      if (!resultProperty) {
        resultProperty = {
          id: property.propertyId,
          name: property.propertyName,
          values: []
        }
        result.push(resultProperty)
      }
      // ② 再处理属性值
      let resultValue = resultProperty.values.find(item => item.id === property.valueId)
      if (!resultValue) {
        resultProperty.values.push({
          id: property.valueId,
          name: property.valueName
        })
      }
    }
  }
  return result;
}

/**
 * 格式化满减送活动的规则
 *
 * @param activity 活动信息
 * @param rule 优惠规格
 * @returns {string} 规格字符串
 */
export function formatRewardActivityRule(activity, rule) {
  if (activity.conditionType === 10) {
    return `满 ${fen2yuan(rule.limit)} 元减 ${fen2yuan(rule.discountPrice)} 元`;
  }
  if (activity.conditionType === 20) {
    return `满 ${rule.limit} 件减 ${fen2yuan(rule.discountPrice)} 元`;
  }
  return '';
}


// 京东订单状态 
export function JDOrderStatus(order) {

  if (order.status === 0) {
    return '待付款';
  }
  if (order.status === 1) {
    return '待确认';
  }
  if (order.status === 2) {
    return '已支付';
  }
  if (order.status === 10) {
    return '已取消';
  }
  if (order.status === 11) {
    return '部分退款';
  }
  if (order.status === 12) {
    return '已退款';
  }
}

